<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
.red-tag {
  color: #ff0000;
}
.para {
  text-indent: 2em;
}
</style>



// WEBPACK FOOTER //
// src/App.vue